export const MODALIDAD_SELECCION_LABELS = {
  // Navigation
  administration: 'Administración',
  modalidadesSeleccion: 'Modalidades de Selección',

  // Actions
  createModalidadSeleccion: 'Crear Modalidad de Selección',
  editModalidadSeleccion: 'Editar Modalidad de Selección',
  save: 'Guardar',
  cancel: 'Cancelar',
  close: 'Cerrar',

  // Form fields
  modalidadSelId: 'ID de Modalidad de Selección',
  codigo: 'Código',
  caracteristicas: 'Características',
  estado: 'Estado',

  // Table
  tableId: 'ID',
  tableCodigo: 'Código',
  tableCaracteristicas: 'Características',
  tableStatus: 'Estado',
  tableActions: 'Acciones',

  // Messages
  loadingModalidadesSeleccion: 'Cargando modalidades de selección...',
  noModalidadesSeleccion: 'No hay modalidades de selección disponibles',

  // Tooltips
  tooltipEdit: 'Editar modalidad de selección',
  tooltipView: 'Ver detalles de la modalidad de selección'
} as const;
